/**
 * LIORA — rangees d'information de la colonne d'achat.
 *
 * Il n'y a plus rien a piloter ici : chaque rangee est un <details> natif, donc
 * c'est le navigateur qui ouvre, ferme, gere le clavier et annonce l'etat aux
 * lecteurs d'ecran. Ce fichier ne fait que declarer l'element conteneur.
 *
 * Il portait auparavant un tiroir lateral : deplacement des panneaux sur <body>,
 * piege de focus, verrou de defilement, fermeture par Echap. Tout cela a ete
 * retire avec le panneau lui-meme — le comportement attendu est celui d'une
 * rangee reductible classique, qui deplie son contenu sur place.
 *
 * Le fichier est conserve plutot que supprime : le bloc parent l'appelle en
 * <script src>, et l'element <liora-info-rows> reste le conteneur qui porte les
 * variables CSS communes aux rangees.
 */

class LioraInfoRows extends HTMLElement {}

if (!customElements.get('liora-info-rows')) {
  customElements.define('liora-info-rows', LioraInfoRows);
}
